<template>
  <div v-if="shouldRender">
    <ais-instant-search
      :search-client="searchClient"
      :index-name="indexName"
      :insights="true"
    >
      <ais-configure :hitsPerPage="hitsPerPage" />
      <ais-autocomplete>
        <template v-slot="{ currentRefinement, indices, refine }">
          <div class="ais-search-input">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M8 0a8 8 0 0 1 8 8c0 1.849-.63 3.549-1.683 4.903l5.39 5.39a1 1 0 1 1-1.414 1.414l-5.39-5.39A7.96 7.96 0 0 1 8 16 8 8 0 1 1 8 0m0 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2"/></svg>
            <input
              autocomplete="off"
              type="search"
              name="for"
              id=""
              placeholder="Search"
              v-model="query"
              @input="refine($event.currentTarget.value.toLowerCase())"
              v-on:keyup.enter="goToAllResults"
              v-on:keyup.escape="clearQuery"
            />
          </div>
          <template v-if="currentRefinement && query.length">
            <template v-for="index in indices" :key="index.indexId">
              <template v-if="index.hits.length">
                <div v-if="index.hits.length" role="listbox">
                  <ais-hits>
                    <template v-slot:item="{ item, sendEvent }">
                      <a
                        @click="
                          sendEvent('click', item, 'Resource Clicked')
                        "
                        :href="item.url"
                      >
                        <div>
                          <h4 class="type-p-2-semibold">{{ item.headline }}</h4>
                          <p v-if="item.summary" class="type-p-3-regular">{{ item.summary }}</p>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 12" height="12" width="17" aria-hidden="true"><path fill="currentColor" d="M13.809 5.222 9.058 1.1l1.108-1.1 6.041 6-6.04 6-1.11-1.102 4.752-4.12H.207V5.222h13.602Z"/></svg>
                      </a>
                    </template>
                  </ais-hits>
                  <div v-if="index.results.nbHits > hitsPerPage" class=" ais-show-all">
                    <a :href="allResultsUrl" class="type-button">
                      Show All Results
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 12" height="12" width="17" aria-hidden="true"><path fill="currentColor" d="M13.809 5.222 9.058 1.1l1.108-1.1 6.041 6-6.04 6-1.11-1.102 4.752-4.12H.207V5.222h13.602Z"/></svg>
                    </a>
                  </div>
                </div>
              </template>
              <p v-else class="ais-no-results">
                No results found
              </p>
            </template>
          </template>
        </template>
      </ais-autocomplete>
    </ais-instant-search>
  </div>
</template>
<script setup>
import { ref, computed } from "vue";
import { liteClient } from "algoliasearch/lite";

const props = defineProps({
  applicationId: {
    type: String,
    default: "",
  },
  searchApiKey: {
    type: String,
    default: "",
  },
  indexPrefix: {
    type: String,
    default: "",
  },
  index: {
    type: String,
    default: "",
  },
});

const searchClient = liteClient(props.applicationId, props.searchApiKey);

const indexName = computed(() => {
  return `${props.indexPrefix}_${props.index}`;
});

const query = ref("");
const hitsPerPage = 3;

const allResultsUrl = computed(() => `/resources/search?for=${query.value}`);

const goToAllResults = () => {
  window.location = allResultsUrl.value;
};

const clearQuery = () => {
  query.value = "";
};

// Check if all required props are provided and valid
const shouldRender = computed(() => {
  return !!(
    props.applicationId &&
    props.searchApiKey &&
    props.indexPrefix &&
    props.index
  );
});
</script>
